import { createContext, useContext } from 'react';
import { assertContextValue } from './createContext';
import { FormPageState } from '../state';

const context = createContext<FormPageState<any> | undefined>(undefined);

export const formPageContext = context;
export const FormPageContextProvider = context.Provider;
export const FormPageContextConsumer = context.Consumer;

export const useFormPageContext = () => {
  const value = useContext(context);
  assertContextValue('FormPageContextProvider', value);
  return value;
};
